<template>
  <div
    :class="{
      'kanban': true,
      'kanban--compact': kanban_settings.compactStyle,
      'kanban--column-layout': kanban_settings.columnLayout,
    }">
    <!-- 'kanban-hero-image': true, -->
    <!-- :style="{ 'background-image': 'url(\'' + goal_meta.picture + '\')'}" -->

    <GoalHeader v-if="$route.name !== 'taskpage'" :goal-id="goalId" :filter="filter" />

    <!-- TODO: SUCHE ausblenden wenn goal nix hat -->
    <!-- TODO: Goal type ermitteln -->
    <!-- <pre>{{lanes}}</pre> -->
    <div class="kanban__split-view">

      <template v-if="lanes.$readySome && lanes.$id_list.length > 0">
        <Kanban :goal-id="goalId" :filter="filter" style="flex: auto" />
      </template>
      <div v-else class="kanban-simplified" style="flex: auto">
        <!-- I'm a wonderful heading -->
        <!-- Enjoy the simple things -->
        <!-- TODO: Make text editable -->
        <div class="hero-text">
          <inline-editable-text
            @change="goal_meta.update({ name: $event })"
            :value="goal_meta.name"
            :inline="true"
            :reset-on-update="false"
            :reset-on-cancel="false"
            :lost-focus-is-update="false"
            />
        </div>
      </div>

      <div
        :class="{
          'kanban-take-action': true ,
          'kanban-take-action--show': show_sidebar,
          'kanban-take-action--hide': !show_sidebar,
        }">
        <div class="kanban-take-action__box">
          <div class="kanban-take-action__bg" :style="kanbanTakeActionBgStyle"></div>

          <div v-if="goal_meta.deleted" class="kanban-take-action__content">
            <el-alert  type="error" center show-icon :closable="false" class="my-4">
              This goal is achived and can not be edited anymore.
            </el-alert>
          </div>

          <div v-else class="kanban-take-action__content">

            <div>
              <el-button class="kanban-take-action__chevron-button" @click="show_sidebar = !show_sidebar">
                <font-awesome-icon :icon="[ 'fas', show_sidebar ? 'chevron-right' : 'chevron-left' ]"/>
              </el-button>

              <ellipsis-button
                style="float: right"
                heading="Goal Actions"
                :show-options="['edit', 'slot', 'archive', 'delete']"
                @edit="onGoToGoalSettings()"
                @archive="onDeleteGoal( true )"
                @delete="onDeleteGoal( false )">

                <el-button
                  class="btn-block ml-0"
                  size="mini"
                  @click.prevent="onConvertGoal( !goal_meta.isTeamgoal )">
                  <font-awesome-icon :icon="goal_meta.isTeamgoal ? 'user' : 'user-friends'" class="taskicon" />
                  Convert to {{ goal_meta.isTeamgoal ? 'private goal' : 'team goal' }}
                </el-button>

                <el-button
                  class="btn-block ml-0"
                  size="mini"
                  @click.prevent="onInviteUser">
                  <font-awesome-icon :icon="['fas', 'user-plus']" class="taskicon" />
                  Invite user
                </el-button>

                <el-button
                  disabled
                  class="btn-block ml-0"
                  size="mini"
                  @click.prevent="onLeaveGoal">
                  <font-awesome-icon icon="sign-out-alt" class="taskicon" />
                  Leave goal
                </el-button>
              </ellipsis-button>

              <h2 class="hide-when-small p-1 rounded w-75 text-black text-center" style="text-shadow: 0 1px 0 #fff; background: rgba(255, 255, 255, 0.75)">Take action</h2>
            </div>

            <!-- <pre class="mini-pre">{{lanes.$readySome}} {{lanes.$id_list.length}}</pre> -->
            <div class="kanban-take-action__action-group" v-if="!goal_meta.isTeamgoal">
              <el-button
                v-for="type in commitment_types"
                :key="type.id"
                :disabled="type.disabled"
                @click.prevent="onOpenCommitmentWizard(type.id)"
                size="fat"
                style="width: 100px; height: 140px; font-size: 7pt"
                class="fat-checkbox p-1">
                <img class="fat-checkbox__image" :src="type.src" height="40" />
                <div class="fat-checkbox__text hide-when-small">{{type.text}}</div>
              </el-button>

              <!--
              <el-button
                size="fat"
                style="width: 140px; height: 140px; font-size: 9pt;"
                @click.prevent="onOpenCommitmentWizard()"
                class="fat-checkbox m-2 p-1">
                <font-awesome-icon class="fat-checkbox__image mb-2" icon="plus-circle" size="3x" style="max-width: 100%;" />
                <div class="fat-checkbox__text mb-0 hide-when-small">Add a commitment</div>
              </el-button>
              -->
            </div>

            <div class="text-center">
              <el-button @click="onOpenCommitmentWizard()" class="btn-block mt-2" v-if="goal_meta.isTeamgoal">
                <font-awesome-icon icon="plus-circle" size="1x" />
                <span class="h5 mx-2 px-2 hide-when-small">Add a commitment</span>
              </el-button>

              <el-popover
                placement="left"
                width="250"
                :open-delay="0"
                trigger="click">
                <div class="calendar-top-bar-heading">Import tasks from different sources</div>

                <el-button class="btn-block ml-0 text-left" size="small" @click.prevent="onCreateNewCommitment('TRELLO')" disabled>
                  <i class="dropdown-icon fe fe-zap"></i>
                  Connect Trello
                </el-button>

                <el-button class="btn-block ml-0 text-left" size="small" @click.prevent="onCreateNewCommitment('ASANA')" disabled>
                  <i class="dropdown-icon fe fe-zap"></i>
                  Connect Asana
                </el-button>

                <el-button class="btn-block ml-0 text-left" size="small" @click.prevent="onCreateNewCommitment('JIRA')" disabled>
                  <i class="dropdown-icon fe fe-zap"></i>
                  Connect Jira
                </el-button>

                <el-button class="btn-block ml-0 text-left" size="small" @click.prevent="onCreateNewCommitment('WUNDERLIST')" disabled>
                  <i class="dropdown-icon fe fe-zap"></i>
                  Connect Wunderlist
                </el-button>

                <el-button class="btn-block ml-0 text-left" size="small" @click.prevent="onCreateNewCommitment('TODOIST')" disabled>
                  <i class="dropdown-icon fe fe-zap"></i>
                  Connect Todoist
                </el-button>

                <el-button class="btn-block ml-0 text-left" size="small" @click.prevent="onImportCommitment">
                  <font-awesome-icon icon="file-upload" />
                  Import Tasklist from file
                </el-button>

                <el-button slot="reference" class="btn-block mt-2">
                  <font-awesome-icon :icon="['far', 'caret-square-down']" />
                  <span class="h5 mx-2 px-2 hide-when-small">Connect source &hellip;</span>
                </el-button>
              </el-popover>

              <el-button @click.prevent="onQuickAddTasklane()" class="btn-block mt-2">
                <font-awesome-icon icon="tasks" size="1x" />
                <span class="h5 mx-2 px-2 hide-when-small">Add an empty tasklist</span>
              </el-button>

            </div>

            <div class="pt-4 hide-when-small" v-if="goal_meta.isTeamgoal">
              <h4>Team features</h4>
              <router-link :to="'/goal/' + $route.params.goalId + '/budget'" class="">
                <el-button class="btn-block mt-2">
                  <el-badge value="Pro">Budget</el-badge>
                </el-button>
              </router-link>

              <router-link :to="'/goal/' + $route.params.goalId + '/timeline'" class="">
                <el-button class="btn-block mt-2">
                  <el-badge value="Pro">Timeline</el-badge>
                </el-button>
              </router-link>

              <router-link :to="'/goal/' + $route.params.goalId + '/reports'" class="">
                <el-button class="btn-block mt-2">
                  <el-badge value="Pro">Reports</el-badge>
                </el-button>
              </router-link>
            </div>

            <div class="mt-5" v-if="goal_meta.description && show_sidebar">
              <h5>Goal description</h5>
              <div class="kanban-dashboard-description mt-2 p-2">
                <markdown-text
                  @input="goal_meta.update({ description: $event })"
                  :value="goal_meta.description"
                  :show-as-markdown="true"
                  :enable-inline-editing="true"  />
              </div>
            </div>

            <router-link :to="'/goal/' + goalId + '/settings'" style="margin-top: auto">
              <el-button class="btn-block">
                <font-awesome-icon icon="wrench" />
                <span class="h5 mx-2 px-2 hide-when-small">Settings</span>
              </el-button>
            </router-link>
          </div>

          <!--
          <el-input type="number" v-model="offset_x" />
          <el-input type="number" v-model="offset_y" />
          -->

          <!--
          <el-button @click.prevent="onQuickAddTasklane()" class="btn-block ml-0 text-left">
            <font-awesome-icon icon="tasks" size="1x" />
            Add tasklist
          </el-button>

          <el-button @click.prevent="onOpenCommitmentWizard()" class="btn-block ml-0 text-left">
            <font-awesome-icon icon="plus-circle" size="1x" />
            Add new commitment
          </el-button>

          <el-button @click.prevent="onOpenCommitmentWizard()" class="btn-block mt-2 ml-0">
            <font-awesome-icon icon="plus-circle" />
            <span class="h5 mx-2">Add a commitment</span>
          </el-button>
          -->

<!-- class="hide-when-small" style="position: absolute; bottom: 0.5em; right: 1em;" -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapReady } from '@/api/misc'
import GoalHeader from './GoalHeader'
import Kanban from './Kanban'
import FilePromptMixin from '@/components/Mixins/Prompts/FilePrompt'
import * as $ from "jquery";
// import textFit from 'textfit';
import { COMMITMENT_TYPES } from '@/components/Config/types.js'
import InvitePromptMixin from '@/components/Mixins/Prompts/InvitePrompt'
import GoalManagementMixin from "@/components/Mixins/GoalManagement"

export default {
  mixins: [ InvitePromptMixin, FilePromptMixin, GoalManagementMixin ],
  props: {
    goalId: {
      default: null,
    }
  },
  data: () => ({
    filter: {
      show_unassigned_tasks: false,
      show_label: null,
      search_text: '',
    },
    takeActionPositions: {
      heroWidth:  1000,
      heroHeight: 1000,
      boxLeft:    0,
      boxTop:     0,
    },
    offset_x: -55, // -19,
    offset_y: -55, // -29,
    commitment_types: COMMITMENT_TYPES,
  }),
  mounted() {
    this.resizeListener = () => this.updateBackgroundPosition()
    window.addEventListener('resize', this.resizeListener);
    this.updateBackgroundPosition();

    /*
    textFit(document.getElementsByClassName('kanban-simplified'), {
      alignVert: false,
      alignHoriz: false,
      multiLine: false,
    });
    */
  },
  beforeDestroy() {
    if ( this.resizeListener ) {
      window.removeEventListener('resize', this.resizeListener)
    }
  },
  computed: {
    ...mapReady('commitments'),

    show_sidebar: {
      get() {
        // Always show, when goal has been deleted
        return ( this.goal_user_settings.kanbanSettings || {} ).showSidebar || this.goal_meta.deleted;
      },
      set( value ) {
        this.goal_user_settings.update({ 'kanbanSettings/showSidebar': value })
      }
    },

    kanbanTakeActionBgStyle() {
      const px = (v) => (v + 'px')
      return {
        backgroundImage: 'url("' + this.goal_meta.picture + '")',
        width:        px(   this.takeActionPositions.heroWidth ),
        height:       px(   this.takeActionPositions.heroHeight ),
        marginLeft:   px( -this.takeActionPositions.boxLeft - this.offset_x ),
        marginTop :   px( -this.takeActionPositions.boxTop - this.offset_y ),
        marginBottom: px( -this.takeActionPositions.heroHeight
                          + this.takeActionPositions.boxTop + this.offset_y ),
      }
    },

    goal_user_settings() {
      return this.$models.userGoalSettings.getNode( this.goalId ) || {};
    },

    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },

    lanes() {
      return this.$models.commitmentMeta.with({ goalId: this.goalId }).getList();
    },

    kanban_settings() {
      return this.goal_user_settings.kanbanSettings || {};
    },
  },
  methods: {

    updateBackgroundPosition() {
      this.takeActionPositions = {
        heroWidth:  $('.goal-page-background').width(),
        heroHeight: $('.goal-page-background').height(),
        boxLeft:    $('.kanban-take-action__box').offset().left,
        boxTop:     $('.kanban-take-action__box').offset().top,
      }
    },

    onOpenCommitmentWizard( type = null ) {
      console.log("type", type)
      // this.$root.showModal('commitment-wizard', type);
      this.$root.showNewModal('effort', {
        goalId: this.goalId,
        type: type,
        tscId: null,
        showWizard: true
      });
    },

    onCreateNewCommitment( type ) {
      this.$root.showNewModal('effort', {
        goalId: this.goalId,
        type:   type
      });
    },

    onImportCommitment() {
      this.$file_prompt({
        accept: '.json,application/json'
      }).then(({ file, done }) => {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = (e) => {
            let json;
            try {
              json = JSON.parse(e.target.result);
            } catch (ex) {
              reject(ex);
              return
            }
            done()
            resolve(json)
          }
          reader.readAsText( file.raw );
        })
      }).then(json => {
        this.$api.commitment_import_from_json({
          goal_id:       this.goalId,
          json:          json
        }).then(() => {
          this.$message('Tasklist successfully imported');
        })
      }).catch(error => {
        this.$message.error('Can not read file: ' + error);
      })
    },

    onQuickAddTasklane() {
      this.$api.commitment_create({
        type:    'BACKLOG',
        goal_id: this.goalId,
        data:    { name: '' }
      });
    },
  },
  components: {
    GoalHeader,
    Kanban,
  }
};
</script>

<style>
@media only screen and (max-width: 600px) {
  .goalheader-actionbar {
    flex-direction: column;
  }
}
.kanban__split-view {
  display: flex;
  width: 100%;
}
.kanban .no-content {
  background-color: rgba(255, 255, 255, 0.95);
  width: 400px;
  margin: 0 auto;
  position: relative;
  top: 5em;
  padding: 2em;
  border-radius: 0.5em;
}
/* *** *** *** *** *** *** *** *** *** *** *** *** *** *** */
.kanban-take-action {
  /*padding: 10px;*/
  /*display: flex;*/
}
.kanban-take-action--show {
  width: 360px;
  flex: 0 0 360px;
}

.kanban-take-action__action-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.kanban-take-action__action-group::after {
  content: "";
  flex: initial;
  width: 100px;
}
.kanban-take-action__action-group > .el-button {
  margin: 0;
  margin-top: 1em;
}
.kanban-take-action--hide .kanban-take-action__action-group > .el-button {
  margin-top: 0.5em;
  border-width: 1px;
  border-radius: 4px;
}

.kanban-take-action__chevron-button {
  padding: 0.3em 0.75em;
  float: right;
  margin-left: 0.5em
}

.kanban-take-action--hide .ellipsis-button {
  width: 100%;
}
.kanban-take-action--hide .ellipsis-button__button,
.kanban-take-action--hide .kanban-take-action__chevron-button {
  margin: 0;
  padding: 0;
  float: none;
  display: block;
  width: 100%;
  margin-top: 5px;
}

.kanban-take-action--hide .kanban-take-action__box {
  width: 50px;
}
.kanban-take-action--hide .kanban-take-action__content > .el-button {
  /*float: none !important;*/
  /*margin: 0 !important;*/
}
.kanban-take-action--hide .kanban-take-action__content .fat-checkbox {
  height: 64px !important;
}
.kanban-take-action--hide .kanban-take-action__content {
  padding: 5px;
  overflow-y: auto;
}
.kanban-take-action--hide .el-button {
  padding: 8px 0;
}
.kanban-take-action--hide .hide-when-small {
  display: none;
}
/*
.kanban-take-action__box {
  border: 1px solid #fff;
  border-radius: 5px;
  margin: 0;
  width: 360px;
  overflow: hidden;
  z-index: 0;
  position: fixed;
  right: 1em;
  height: calc(100vh - 120px);
}
*/
.kanban-take-action__box {
  border-left: 1px solid #fff;
  margin: 0;
  overflow: hidden;
  z-index: 0;
  /*
  width: 360px;
  position: fixed;
  top: 82px;
  right: 0;
  height: calc(100vh - 82px);
  */
  flex: 0 0 360px;
  position: relative;
}
.kanban-dashboard-description {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.19);
}
.kanban-take-action__bg {
  position: absolute;
  background-color: white;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -1;
  -webkit-filter: blur(18px);
  -moz-filter: blur(18px);
  -ms-filter: blur(18px);
  filter: blur(18px);
  filter: progid: DXImageTransform.Microsoft.Blur(PixelRadius=18, MakeShadow=false);
}
.kanban-take-action__content {
  padding: 20px;
  background-color: #ffffff7a;
  height: calc(100vh - 50px);
  width: 100%;
  color: black;
  overflow-y: scroll;
      display: flex;
    flex-direction: column;
}
/* *** *** *** *** *** *** *** *** *** *** *** *** *** *** */
.kanban-simplified .inline-editable-text.is-inline .inline-editable-text__text:focus,
.kanban-simplified .inline-editable-text.is-inline .inline-editable-text__text:hover {
  color: black;
}
.kanban-simplified .inline-editable-text {
  position: absolute;
  top: 0;
  left: 0;
  border: 20px solid white;
  padding: 150px 50px;
  margin: 120px 0 0 100px;
  width: calc(100vw - 600px);
  max-height: calc(100vh - 300px);
  max-width: 600px;
  /*font-size: 28pt;*/
  font-size: 10vh;
  color: white;
  background-color: #0000005e; /* TODO: Set automatically based on pic */
  text-transform: uppercase;
  letter-spacing: 3px;
  /*font-family: "Source Sans Pro";*/
  /*font-family: 'Roboto Condensed', sans-serif;*/
  font-weight: 900;
  font-style: normal;
  line-height: 1.1;
  /*max-height: calc(100vh - 280px);*/
}
/* *** *** *** *** *** *** *** *** *** *** *** *** *** *** */
</style>
